"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.configureFramework = void 0;
const authenticator_1 = require("../../authenticator");
const mobileConnector_1 = require("../../mobileConnector");
const configureFramework = (Session) => {
    const Authenticator = new authenticator_1.MbHybridAuthenticator(Session, mobileConnector_1.getAccessToken);
    return {
        Authenticator,
    };
};
exports.configureFramework = configureFramework;
//# sourceMappingURL=base.js.map